import React from 'react';

class Filter extends React.PureComponent {
  constructor(props) {
    super(props)
  }

  render() {
    return <li className={`filter-item ${this.props.active ? 'filter-item--active' : 'filter-item--inactive'}`} data-tag-advanced>
      <label className="filter-text" htmlFor={`filter_${this.props.value.t}`}>
        <input type="checkbox" name={this.props.group} value={this.props.value.t} id={`filter_${this.props.value.t}`} onChange={(e) => this.props.filterChange(e, this.props.value)} defaultChecked={this.props.active} className="filter-item--checkbox" />
        <span className="filter-icon--checkbox">
          <svg aria-hidden="true" focusable="false" role="presentation" width="11" height="11" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" fillRule="evenodd" d="M0,2.00276013 C0,0.896666251 0.893542647,0 2.00276013,0 L10.9972399,0 C12.1033337,0 13,0.893542647 13,2.00276013 L13,10.9972399 C13,12.1033337 12.1064574,13 10.9972399,13 L2.00276013,13 C0.896666251,13 0,12.1064574 0,10.9972399 L0,2.00276013 Z M3.038,6.013 L2,7.024 L5.115,10.061 L11,4.325 L9.962,3.312 L5.115,8.038 L3.038,6.013 Z"></path>
          </svg>
        </span>
        {this.props.value.v}
      </label>
    </li>
  }
}

class CollectionFilter extends React.Component {
  constructor(props) {
    super(props)

    this.filterGroups = props.tags && props.tags.reduce((groups, tag) => {
      if (tag.includes('_')) {
        let tagArray = tag.split('_')
        if (groups[tagArray[0]]) {
          groups[tagArray[0]].push({ "v": tagArray[1], "t": tag })
        } else {
          groups[tagArray[0]] = [{ "v": tagArray[1], "t": tag }]
        }
      }
      return groups
    }, {})

    this.state = {
      currentFilters: this.props.currentFilters
    }

    this.clickTrapActive = false

    this.filterChange = this.filterChange.bind(this)
    // this.filterClick = this.filterClick.bind(this)
    // this.clickTrap = this.clickTrap.bind(this)
    this.updateCollection = this.props.callback
    this.closeModal = this.closeModal.bind(this)
  }

  filterChange(e, value) {
    if (!e.currentTarget) {
      return;
    }

    let currentFilters = this.state.currentFilters;

    if (e.currentTarget.checked) {
      currentFilters.add(value.t)
    } else {
      currentFilters.delete(value.t)
    }

    this.setState({
      currentFilters
    })

    this.updateCollection(this.state.currentFilters)
  }

  closeModal() {
    this.props.closeFn()
  }

  /* clickTrap(e) {
    this.clickTrapActive = false;
    if (!e.target.matches(`.filter.expanded *`)) {
      e.preventDefault()
    }
    document.querySelector('.filter.expanded').classList.remove('expanded')
    document.removeEventListener('click', this.clickTrap)
  }

  filterClick(e) {
    if (this.clickTrapActive) {
      if (e.target.matches('.filter.expanded .filter-heading')) {
        return;
      }
      document.querySelectorAll('.filter.expanded').forEach(el => el.classList.remove('expanded'))
      document.removeEventListener('click', this.clickTrap)
    }
    const parentEl = e.currentTarget.parentElement;
    parentEl.classList.add('expanded');
    this.clickTrapActive = true;

    document.addEventListener('click', this.clickTrap)
  } */

  render() {
    return <div className="productgrid--sidebar">
      <div className="productgrid--sidebar-section" data-productgrid-filters-content>
        {
          Object.keys(this.filterGroups).map((group) => {
            return <div className="filter" key={group}>
              <h3 className="productgrid--sidebar-title--small">{group}</h3>
              <ul className="productgrid--sidebar-item filter-group" data-filter-group={group}>
                {this.filterGroups[group].map(value => {
                  return <Filter value={value} group={group} active={this.state.currentFilters.has(value.t)} key={value.t} filterChange={this.filterChange} />
                })}
              </ul>
            </div>
          })
        }
        <div className="productgrid--filter-apply">
          <button className="productgrid--filter-apply-button" onClick={this.closeModal}>Apply</button>
        </div>
      </div>
    </div>
  }
}

export default CollectionFilter